import Vue from 'vue'
import Router from 'vue-router'
import SoftwareVersionHome from "./views/SoftwareVersionHome";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: SoftwareVersionHome
    }
  ]
})
